export const PaddingAndMarginBasic = `
<div className="bd-example example-padding text-white" style={{padding: "0rem"}}>
  <div className="p-0">p-0</div>
  <div className="p-1">p-1</div>
  <div className="p-2">p-2</div>
  <div className="p-3">p-3</div>
  <div className="p-4">p-4</div>
  <div className="p-5">p-5</div>
</div>
`

export const PaddingAndMarginMore = `
<div className="bd-example text-white example-margin" style={{padding: "0rem"}}>
  <div className="m-0">m-0</div>
  <div className="m-1">m-1</div>
  <div className="m-2">m-2</div>
  <div className="m-3">m-3</div>
  <div className="m-4">m-4</div>
  <div className="m-5">m-5</div>
</div>
`

export const PaddingAndMarginHHorizontalCenter = `
<div className="mx-auto bg-light" style={{width: "200px"}}>
  Centered element
</div>
`
